import {EventBus} from "../../../common/ts/events/EventBus";
import {PushManagerSubscriptionCreatedEvent, PushManagerSubscriptionStatus} from "./events";
import {WhitelabelEvent} from "../../../common/ts/events/Events";

export class WPNEventHandlers {
    private readonly eventBus: EventBus

    constructor(eventBus: EventBus) {
        this.eventBus = eventBus
    }

    init() {
        this.eventBus.subscribeWithId(PushManagerSubscriptionCreatedEvent.TYPE, {
            id: `${PushManagerSubscriptionCreatedEvent.TYPE}-handler`,
            callback: this.webPushSubscriptionCreatedEventHandler.bind(this),
        })
    }

    private async webPushSubscriptionCreatedEventHandler(event: WhitelabelEvent) {
        await this.newPushSubscription(
            this.getAlertParamsFromPointOfCaptureModal(event as PushManagerSubscriptionCreatedEvent)
        )
    }

    private getAlertParamsFromPointOfCaptureModal(event: PushManagerSubscriptionCreatedEvent): any[] {
        const {payload} = event
        const actionSearch = window.location.search !== ''
        const pointOfCaptureModal = document.querySelector('.js-serp-email-capture-modal') as HTMLElement
        if (!pointOfCaptureModal) return []
        const postPayload = []
        const dataset = pointOfCaptureModal?.dataset || {}
        postPayload.push({name: 'endpoint', value: payload.endpoint})
        postPayload.push({name: 'auth', value: payload.auth})
        postPayload.push({name: 'key', value: payload.key})
        postPayload.push({
            name: 'statusType',
            value: payload.status === PushManagerSubscriptionStatus.ALLOWED ? "subscribe" : "init"
        })
        postPayload.push({name: 'operation', value: 'newpush'})
        postPayload.push({name: 'locAlert', value: dataset.location || ''})
        postPayload.push({name: 'action_search', value: actionSearch})
        postPayload.push({name: 'location', value: dataset.location || ''})
        postPayload.push({name: 'listing_type', value: dataset.listingType || ''})
        postPayload.push({name: 'property_type', value: dataset.propertyType || ''})
        postPayload.push({name: 'bedrooms', value: dataset.bedrooms || ''})
        postPayload.push({name: 'bathrooms', value: dataset.bathrooms || ''})
        postPayload.push({name: 'price_min', value: dataset.priceMin || ''})
        postPayload.push({name: 'price_max', value: dataset.priceMax || ''})
        postPayload.push({name: 'size_min', value: dataset.sizeMin || ''})
        postPayload.push({name: 'size_max', value: dataset.sizeMax || ''})
        return postPayload
    }

    private async newPushSubscription(payload: any[]) {
        if (payload.length === 0) return
        await fetch('/newPushSub', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: this.urlEncodedBody(payload)
        })
    }

    private urlEncodedBody(payload: any[]): string {
        return payload
            .map(item => encodeURIComponent(item.name) + '=' + encodeURIComponent(item.value))
            .join('&')
    }
}
